export type NotificationType = 'info' | 'success' | 'unlock' | 'warning';

export interface NotificationEntry {
  id: string;
  text: string;
  type: NotificationType;
  durationSec: number;
  elapsedSec: number;
}

export interface NotificationLogOptions {
  maxEntries?: number;
  durationSec?: number;
  containerElement?: HTMLElement | null;
}

export class NotificationLog {
  private entries: NotificationEntry[] = [];
  public readonly maxEntries: number;
  public readonly defaultDurationSec: number;
  private container: HTMLElement | null = null;

  constructor(options: NotificationLogOptions = {}) {
    this.maxEntries = options.maxEntries ?? 5;
    this.defaultDurationSec = options.durationSec ?? 3.5;

    if (options.containerElement !== undefined) {
      this.container = options.containerElement;
    } else if (typeof document !== 'undefined') {
      this.container = document.getElementById('hud-toast-log');
    }
  }

  public add(text: string, type: NotificationType = 'info', durationSec?: number): void {
    const entry: NotificationEntry = {
      id: Math.random().toString(36).substring(2, 9),
      text,
      type,
      durationSec: durationSec ?? this.defaultDurationSec,
      elapsedSec: 0
    };

    this.entries.push(entry);
    if (this.entries.length > this.maxEntries) {
      this.entries.shift();
    }

    this.render();
  }

  public getEntries(): readonly NotificationEntry[] {
    return this.entries;
  }

  public update(dt: number): void {
    let changed = false;
    const remaining: NotificationEntry[] = [];

    for (const entry of this.entries) {
      entry.elapsedSec += dt;
      if (entry.elapsedSec < entry.durationSec) {
        remaining.push(entry);
      } else {
        changed = true;
      }
    }

    if (changed) {
      this.entries = remaining;
      this.render();
    }
  }

  private render(): void {
    if (!this.container) return;
    this.container.innerHTML = this.entries
      .map((e) => `<div class="toast-item toast-${e.type}">${e.text}</div>`)
      .join('');
  }
}
